<div class="container mt-5 text-center">
  <h1 class="display-4" [attr.aria-label]="'Error 404' | translate">404</h1>
  <p class="lead">{{ 'Page Not Found' | translate }}</p>
  <p>{{ 'The page you are looking for does not exist.' | translate }}</p>
  <a routerLink="/Personal-Dashboard" class="btn btn-primary">{{ 'Return to Dashboard' | translate }}</a>
</div>
